function buumiInitSliders() {
  document.querySelectorAll('[data-buumi-slider]').forEach(function (root) {
    if (root.dataset.buumiInitialized === 'true') return;
    root.dataset.buumiInitialized = 'true';
    root.classList.add('buumi-slider--ready');

    var track = root.querySelector('.buumi-slider__track');
    if (!track) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('.buumi-slider__slide'));
    var total = slides.length;
    var current = 0;
    var timer = null;

    // Reasigna el índice de cada slide según su orden real en el DOM,
    // sin depender de que Liquid nos pase forloop.index.
    slides.forEach(function (slide, i) {
      slide.dataset.slideIndex = i;
    });

    var autoplayEnabled = root.dataset.autoplay === 'true';
    var autoplaySpeed = parseInt(root.dataset.autoplaySpeed, 10);
    if (!autoplaySpeed || autoplaySpeed < 1000) autoplaySpeed = 5000; // fallback de seguridad

    var dots = [];
    var prevBtn = null;
    var nextBtn = null;

    if (total > 1) {
      var dotsWrap = document.createElement('div');
      dotsWrap.className = 'buumi-slider__dots';
      dotsWrap.setAttribute('role', 'tablist');

      for (var i = 0; i < total; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'buumi-slider__dot';
        dot.dataset.dotIndex = i;
        dot.setAttribute('aria-label', 'Ir al paso ' + (i + 1));
        dotsWrap.appendChild(dot);
        dots.push(dot);
      }
      root.appendChild(dotsWrap);

      prevBtn = document.createElement('button');
      prevBtn.type = 'button';
      prevBtn.className = 'buumi-slider__arrow buumi-slider__arrow--prev';
      prevBtn.setAttribute('aria-label', 'Anterior');
      prevBtn.textContent = '‹';
      root.appendChild(prevBtn);

      nextBtn = document.createElement('button');
      nextBtn.type = 'button';
      nextBtn.className = 'buumi-slider__arrow buumi-slider__arrow--next';
      nextBtn.setAttribute('aria-label', 'Siguiente');
      nextBtn.textContent = '›';
      root.appendChild(nextBtn);
    }

    function goTo(index) {
      current = (index + total) % total;
      slides.forEach(function (slide) {
        slide.classList.toggle(
          'is-active',
          parseInt(slide.dataset.slideIndex, 10) === current
        );
      });
      dots.forEach(function (dot) {
        dot.classList.toggle(
          'is-active',
          parseInt(dot.dataset.dotIndex, 10) === current
        );
      });
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAutoplay() {
      if (!autoplayEnabled || total < 2) return;
      stopAutoplay();
      timer = setInterval(next, autoplaySpeed);
    }

    function stopAutoplay() {
      if (timer) clearInterval(timer);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.dotIndex, 10));
        startAutoplay();
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () { prev(); startAutoplay(); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { next(); startAutoplay(); });
    }

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    // Efecto de arco/ola en los títulos
    root.querySelectorAll('[data-wave-text]').forEach(function (el) {
      if (el.dataset.waveApplied === 'true') return;
      el.dataset.waveApplied = 'true';

      var text = el.textContent;
      var chars = Array.prototype.slice.call(text);
      var n = chars.length;
      el.textContent = '';

      var maxAngle = 10;
      var curveHeight = 12;

      chars.forEach(function (char, i) {
        var span = document.createElement('span');
        span.textContent = char === ' ' ? '\u00A0' : char;
        var t = n > 1 ? (i / (n - 1)) - 0.5 : 0;
        var angle = t * maxAngle * 2;
        var y = -curveHeight * (1 - Math.pow(t * 2, 2));
        span.style.transform = 'translateY(' + y + 'px) rotate(' + angle + 'deg)';
        el.appendChild(span);
      });
    });

    goTo(0);
    startAutoplay();
  });
}

document.addEventListener('DOMContentLoaded', buumiInitSliders);
document.addEventListener('shopify:section:load', buumiInitSliders);
document.addEventListener('shopify:block:select', buumiInitSliders);